import styled from "styled-components";
import { Paper } from "@mui/material";

export const SubHeading = styled.p`
  font-family: MuseoSans;
  font-weight: 400;
  line-height: 1.5;
  margin-bottom: 1.5rem;
  font-size: 1.5rem; 
  margin-top: 0;

    '@media (min-width:600px)': {
      fontSize: 0.875rem,
    },
    [theme.breakpoints.up('md')]: {
      fontSize: '1.5rem',
    },
`;

export const CounterLabel = styled.label`
  font-size: 1rem;
  line-height: 1.5rem;
  font-family: "MuseoSans";
  font-weight: 200;
  // margin-bottom: 40px;
`;

export const TermsLabel = styled.label`
  font-size: 1rem;
  color: #474b55;
  font-family: "MuseoSans";
  line-height: 1.5rem;
  font-weight: 200;
  width: 100%;
`;

export const Small = styled.span`
  font-size: 0.975rem;
  font-weight: 200;
  font-family: "MuseoSans";
  line-height: 1.5rem;
  color: #474b55;
`;

export const Counter = styled.span`
  bottom: 20px;
  font-size: 13px;
  font-style: italic;
  position: absolute;
  right: 15px;
  font-weight: 200;
  font-family: "MuseoSans";
`;
export const CounterWrap = styled.div`
  position: relative !important;
  margin-bottom: 1rem !important;
  width: 100%;
`;

export const FormContainer = styled(Paper)(({ theme }) => ({
  ...theme.typography.body2,
  width: "100%",
  paddingTop: "50px",
  lineHeight: "0.5",
  fontFamily: "MuseoSans",
  fontSize: "1.728rem",
  color: "#003863",
  fontWeight: "400",
}));

export const Title = styled.p`
  color: #003863;
  font-size: 1.5rem;
  @media (max-width: 992px) {
    display: none;
  }
`;

export const HeaderImage = styled.img`
  max-width: 244px;
  max-height: 59px;
  margin-top: 5px;
  padding-right: 20px;
`;

export const FooterContainer = styled.div`
  background-color: #474b55;
  color: #fff;
  font-family: MuseoSans;
  font-weight: 300;
  font-size: 14px;
  align-content: center;
`;

export const FooterLink = styled.a`
  color: #fff;
  font-family: MuseoSans;
  font-weight: 300;
  font-size: 14px;
  text-decoration: none;
  padding: 8px;
`;

export const SuccessMessage = styled.strong`
  font-family: "MuseoSans";
  font-size: 1rem;
  color: #213c15;
  font-weight: 400;
`;

export const RecaptchaMessage = styled.div`
  font-family: "MuseoSans";
  font-size: 0.75rem;
  color: #c10000;
  font-weight: 400;
  padding-top: 2px;
`
